var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EspMediaGallery',{attrs:{"mediaList":_vm.images},on:{"videoActivate":function($event){return _vm.$emit('videoActivate')}}})}
var staticRenderFns = []

export { render, staticRenderFns }